import React from 'react';
import { Button, useWidth } from 'vindi-ds-components';
import Token from 'vindi-ds-tokens';
import styles from './styles';
import ScaffoldCard from './scaffold_card';
import CardLinks from './card_links';

function LockedCard({ ButtonIcon, ...props }) {
  const { buttonLabel, isCompleted } = props;
  const mobile = ['xs', 'sm', 'md'].includes(useWidth());

  const LockedLinks = () => (
    <CardLinks mobile={mobile} {...props}>
      <Button variant='secondary' disabled style={styles.buttonLocked} width={mobile ? '100%' : '208px'}>
        <ButtonIcon />
        {buttonLabel}
      </Button>
    </CardLinks>
  );

  return (
    <ScaffoldCard
      css={styles.locked}
      CardLinks={LockedLinks}
      iconColor={Token.color.functional.light[500].value}
      {...props}
      isCompleted={isCompleted}
    />
  );
}

export default LockedCard;
